import { Page } from 'components';
import { useContext } from 'react';
import {  Filters, Results } from './components';
import { TicketPrioritiesContext } from './TicketPrioritiesContext';

let TicketPriorities = () => {
    let { isLoading } = useContext(TicketPrioritiesContext);

    return (
        <Page
            isLoading={isLoading}
            useHeader={true}
            title="Ticket Priorities"
            addNewUrl="/admin/ticketPriority/addnew"
        >
            <Filters/>
            <Results />
        </Page>
    )
}

export default TicketPriorities;